module.exports = __webpack_public_path__ + "img/6-1.c3d0ff97.jpg";